module.exports = __webpack_public_path__ + "assets/img/5343c92abd302b3d6e70e50985a18ab7.png";